import { render, staticRenderFns } from "./GraphDetail08.vue?vue&type=template&id=ef12f40a&scoped=true&"
import script from "./GraphDetail08.vue?vue&type=script&lang=js&"
export * from "./GraphDetail08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef12f40a",
  null
  
)

export default component.exports